import classNames from "classnames";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./HeightAnimationContainer.module.less";

export type HeightAnimationContainerProps = {
	isVisible: boolean;
};

export const HeightAnimationContainer = (props: PropsWithChildren<HeightAnimationContainerProps>): ReactElement => {
	const {
		isVisible,
		children
	} = props;

	return (
		<div
			className={classNames(
				styles.root,
				{ [styles.root_visible]: isVisible }
			)}
		>
			<div className={styles.dontRemoveMe}>
				{children}
			</div>
		</div>
	);
};
HeightAnimationContainer.displayName = "HeightAnimationContainer";
